import { AsyncPipe,NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { EnvironmentTypes } from '../../../environments/environment-types';
import { GaMetricComponent } from '../../shared/components/metric/ga-metric/ga-metric.component';
import { GtagMetricComponent } from '../../shared/components/metric/gtag-metric/gtag-metric.component';
import { YaMetricComponent } from '../../shared/components/metric/ya-metric/ya-metric.component';
import { ConfigRepository } from '../../shared/repositories/config.repository';

interface MetricCodes {
  yam: string[] | undefined | null
  ga: string[] | undefined | null
  gtag: string[] | undefined | null
}

@Component({
    selector: 'app-metric-footer',
    templateUrl: './metric-footer.component.html',
    standalone: true,
    imports: [NgIf, YaMetricComponent, GaMetricComponent, GtagMetricComponent, AsyncPipe]
})
export class MetricFooterComponent {
  constructor(
    private configRepository: ConfigRepository,
  ) { }

  environmentType = environment.type;
  environmentTypes = EnvironmentTypes;

  currentEnvironment: EnvironmentTypes = environment.type;

  metricCodes$: Observable<MetricCodes> = combineLatest({
    yam: this.configRepository.yandexAnalyticsCodes$,
    ga: this.configRepository.googleAnalyticsCodes$,
    gtag: this.configRepository.googleTagManagerCodes$,
  });
}
